
/* injects from baggage-loader */

'use strict';

import CreateProductVariantModalComponent from './createProductVariantModal.component';
import './createProductVariantModal.scss';

const CreateProductVariantModalModule = angular.module('create-product-variant-modal-module', []);

CreateProductVariantModalModule
    .component('createProductVariantModal', new CreateProductVariantModalComponent());

export default CreateProductVariantModalModule;




// WEBPACK FOOTER //
// ./src/app/components/createProductVariantModal/createProductVariantModal.module.js